/* eslint-disable */
import { useLocation, useNavigate } from "react-router-dom";
import "../styles/sidebar.css";
// import { IoIosSettings } from "react-icons/io";
import { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { getAllSideBar } from './../masterManagement/actions/masterManagementAction';
const DashboardSidebar = ({ showSidebar }) => {
    const navigate = useNavigate()
    const location = useLocation()
    const selectedFeature = location.pathname.split("/")[2]
    const { navigationpanelList } = useSelector((state) => state.masterManagementReducer, shallowEqual)
    const dispatch = useDispatch()

    const mapFeaturesFromApi = (apiData) => {
        return apiData.map((item) => ({
            name: item.name,
            code: item.code,
            path: item.route,
            icon: item.icon,
            isAllowed: item.isAllowed,
            description: item.description,
            updatedBy: item.updatedBy
        }));
    };

    const features = mapFeaturesFromApi(navigationpanelList);
    
    
    useEffect(() => {
        dispatch(getAllSideBar())
    }, [dispatch])

    
    return (
        <div className={`main ${showSidebar ? 'open' : ''}`}>
            {
                features.map((ele, i) => {
                    return (ele.isAllowed || ele.code === "DASHBOARD_MGMT") && (
                        <div
                            key={i}
                            className={`feature ${showSidebar ? '' : 'closed'} ${selectedFeature === ele.path ? 'div-bg-color' : ''}`}
                            onClick={() => navigate(`/oasadmin/${ele.path}`)}
                        >
                            <div className={`feature-icon ${selectedFeature === ele.path ? 'text-primary' : 'text-secondary'}`}>
                                <i className={`${ele.icon}`} aria-hidden="true"></i>
                            </div>
                            {
                                showSidebar && (
                                    <div className={`feature-label ${selectedFeature === ele.path ? 'text-primary text-nowrap' : ' label-color text-nowrap'}`}>
                                        {ele.name}
                                    </div>
                                )
                            }
                        </div>
                    )
                })
            }
        </div>
    )
}
export default DashboardSidebar;